import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const FeaturedOffers502x272RootActionPath = 'core/FeaturedOffers502x272';

export const FEATURED_OFFERS_502X272_GET_SUCCESS = `${FeaturedOffers502x272RootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const FEATURED_OFFERS_502X272_GET_FAILURE = `${FeaturedOffers502x272RootActionPath}/GET_${FAILURE_SUFFIX}`;

export const FEATURED_OFFERS_502X272_VIEW = `${FeaturedOffers502x272RootActionPath}/VIEW}`;
